module.exports = __webpack_public_path__ + "static/media/1009708.4213b811.png";